module.exports = __webpack_public_path__ + "static/media/gallery-8.8d164e71.jpeg";